/// <reference path="GNOMList.js" />

var SharedListInstance;

class SharedList extends GNOMList {
	constructor(el, options) {
		super(el, Object.assign({ pagingEffect: 'horizSlide', noProgressIndicator: true }, options));
		SharedListInstance = this;
	}

	loadPageWithCustomUrl(page, customUrl) {
		this.customUrl = customUrl;
		this.loadPage(page);
	}

	loadPage(page) {
		super.loadPage(page, this.customUrl);
	}
}
